function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 518"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 517"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 439",
  d: "M18.4 9.311a.6.6 0 00-.328-.081H.385a.6.6 0 00-.327.081c-.07.05-.077.113-.017.167a4.535 4.535 0 002.833.78h12.713a4.544 4.544 0 002.834-.78c.058-.053.053-.116-.021-.167z",
  fill: "#642a4e"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 520"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 519"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 440",
  d: "M10.286 1.618a1.154 1.154 0 10-2.109 0 7.674 7.674 0 00-6.591 6.843h15.289a7.677 7.677 0 00-6.589-6.843zM8.872 3.845a5.371 5.371 0 00-4.719 3.578.386.386 0 01-.363.257.391.391 0 01-.128-.022.386.386 0 01-.235-.491A6.137 6.137 0 018.82 3.078a.39.39 0 01.409.358.384.384 0 01-.357.409z",
  fill: "#642a4e"
})));

function SvgLineFood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18.461 10.258"
  }, props), _ref, _ref2);
}

export default SvgLineFood;